import { render, staticRenderFns } from "./Plaid.vue?vue&type=template&id=68f7d0f5"
import script from "./Plaid.vue?vue&type=script&lang=js"
export * from "./Plaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports